import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var PointOfSaleOutline = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M5 3V13H4C2.90694 13 2 13.9069 2 15V21H4V15H5C5 16.105 5.895 17 7 17H17C18.105 17 19 16.105 19 15H20V21H22V15C22 13.9069 21.0931 13 20 13H19V3H17C17 3.552 16.552 4 16 4C15.448 4 15 3.552 15 3H13C13 3.552 12.552 4 12 4C11.448 4 11 3.552 11 3H9C9 3.552 8.552 4 8 4C7.448 4 7 3.552 7 3H5ZM7 6H17V15H7V6ZM9 8V10H15V8H9ZM9 11V13H13V11H9ZM7 19V21H9V19H7ZM11 19V21H13V19H11ZM15 19V21H17V19H15Z",
    fill: fill
  }));
};
export { PointOfSaleOutline as default };
//# sourceMappingURL=PointOfSaleOutline.js.map
